<template>
    <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
        <AdminNavbar />
        <section class="bg-light">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="filter_search_opt">
                            <a
                                href="#"
                                @click.prevent="show = !show"
                                class="btn btn-dark full-width mb-4"
                            >
                                {{ $t('Dashboard Navigation') }}
                                <i class="fa-solid fa-bars ms-2"></i>
                            </a>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <AdminSidebar
                            :open="show"
                            @update:open="show = $event"
                            :userData="userData"
                            :category-name="categoryName"
                            :state-name="stateName"
                        />
                    </div>

                    <div class="col-lg-9 col-md-12">

                        <div class="dashboard-wraper">
                            <div class="d-flex justify-content-between align-items-center mb-4">
                                <h4 class="mb-0">{{ $t('Add Branch') }}</h4>
                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    @click="goBack"
                                >
                                    {{ $t('Back') }}
                                </button>
                            </div>


                            <!-- Form -->
                            <form @submit.prevent="submitBranch">
                                <div class="row">
                                    <!-- Branch Names -->
                                    <div class="col-lg-12">
                                        <div class="form-group mb-4">

                                            <div class="mb-3">
                                                <label class="form-label fw-bold">{{ $t('Branch Name') }}</label>

                                                <small class="d-block text-muted">
                                                    {{ $t('Enter the branch name in all supported languages.') }}
                                                </small>
                                            </div>

                                            <div class="row">

                                                <!-- English -->
                                                <div class="col-lg-4 col-md-6 mb-3">
                                                    <label class="form-label">
                                                        {{ $t('English') }}
                                                        <span class="text-muted">(English)</span>
                                                        <span class="text-danger">*</span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="branchForm.translations.en.name"
                                                        :placeholder="$t('Enter branch name in English')"
                                                    />

                                                    <small
                                                        v-if="errors['translations.en.name']"
                                                        class="text-danger"
                                                    >
                                                        {{ errors['translations.en.name'][0] }}
                                                    </small>
                                                </div>

                                                <!-- Arabic -->
                                                <div class="col-lg-4 col-md-6 mb-3">
                                                    <label class="form-label">
                                                        {{ $t('Arabic') }}
                                                        <span class="text-muted">(Arabic)</span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="branchForm.translations.ar.name"
                                                        :placeholder="$t('Enter branch name in Arabic')"
                                                        dir="rtl"
                                                    />

                                                    <small
                                                        v-if="errors['translations.ar.name']"
                                                        class="text-danger"
                                                    >
                                                        {{ errors['translations.ar.name'][0] }}
                                                    </small>
                                                </div>

                                                <!-- Turkish -->
                                                <div class="col-lg-4 col-md-6 mb-3">
                                                    <label class="form-label">
                                                        {{ $t('Turkish') }}
                                                        <span class="text-muted">(Turkish)</span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="branchForm.translations.tr.name"
                                                        :placeholder="$t('Enter branch name in Turkish')"
                                                    />

                                                    <small
                                                        v-if="errors['translations.tr.name']"
                                                        class="text-danger"
                                                    >
                                                        {{ errors['translations.tr.name'][0] }}
                                                    </small>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <!-- State -->
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group mb-3">
                                            <label class="mb-1">{{ $t('State') }}</label>
                                            <span class="text-danger">*</span>
                                            <select
                                                class="form-control"
                                                v-model="branchForm.state_id"
                                            >
                                                <option
                                                    disabled
                                                    value=""
                                                >
                                                    {{ $t('Select State') }}
                                                </option>
                                                <option
                                                    v-for="state in states"
                                                    :key="state.id"
                                                    :value="state.id"
                                                >
                                                    {{ state.name }}
                                                </option>
                                            </select>
                                            <small
                                                v-if="errors.state_id"
                                                class="text-danger"
                                            >
                                                {{ errors.state_id[0] }}
                                            </small>
                                        </div>
                                    </div>

                                    <!-- City -->
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group mb-3">
                                            <label class="mb-1">{{ $t('Area') }}</label>
                                            <span class="text-danger">*</span>

                                            <select
                                                class="form-control"
                                                v-model="branchForm.city_id"
                                            >
                                                <option
                                                    disabled
                                                    value=""
                                                >
                                                    {{ $t('Select Area') }}
                                                </option>

                                                <option
                                                    v-for="city in cities"
                                                    :key="city.id"
                                                    :value="city.id"
                                                >
                                                    {{ city.name }}
                                                </option>
                                            </select>
                                            <small
                                                v-if="errors.city_id"
                                                class="text-danger"
                                            >
                                                {{ errors.city_id[0] }}
                                            </small>
                                        </div>
                                    </div>

                                    <!-- Address -->
                                    <div class="col-lg-6 col-md-6">

                                        <div class="form-group mb-3">

                                            <label class="mb-1">{{ $t('Address') }}</label>
                                            <span class="text-danger">*</span>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="branchForm.address"
                                                :placeholder="$t('Address')"
                                            />
                                            <small
                                                v-if="errors.address"
                                                class="text-danger"
                                            >
                                                {{ errors.address[0] }}
                                            </small>

                                        </div>
                                    </div>


                                    <!-- Map -->
                                    <div class="col-lg-12">
                                        <div class="form-group mb-3">
                                            <label class="mb-2">{{ $t('Location') }}</label>
                                            <MapPicker
                                                :location="location"
                                                :latitude="branchForm.latitude"
                                                :longitude="branchForm.longitude"
                                                @update:location="onLocationChange"
                                            />
                                        </div>
                                    </div>


                                    <!-- Submit -->
                                    <div class="col-lg-12">
                                        <div class="form-group mt-3">
                                            <button
                                                type="submit"
                                                class="btn btn-primary full-width"
                                                :disabled="loading"
                                            >
                                                <span v-if="loading">
                                                    <span
                                                        class="spinner-border spinner-border-sm me-2"
                                                    ></span>
                                                    {{ $t('Saving...') }}
                                                </span>
                                                <span v-else>
                                                    <i class="fa-solid fa-plus me-2"></i>
                                                    {{ $t('Add Branch') }}
                                                </span>
                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </form>

                        </div>

                    </div>

                </div>

            </div>
        </section>


        <FooterTop :bg="'theme-bg'" />

        <FooterDark />

        <ScrollToTop />

    </div>
</template>


<script setup>

import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';

import AdminSidebar from '@/components/admin-sidebar.vue';
import AdminNavbar from '@/components/navbar/admin-navbar.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import MapPicker from '@/components/MapPicker.vue';


const router = useRouter();

const { t, locale } = useI18n();

const toast = useToast();

const token = localStorage.getItem('auth_token');

// Sidebar
const show = ref(false);
const userData = ref(null);

// Branch form
const branchForm = ref({
    translations: {
        en: {
            name: ''
        },
        ar: {
            name: ''
        },
        tr: {
            name: ''
        }
    },
    state_id: '',
    city_id: '',
    address: '',
    latitude: '',
    longitude: ''
});

// Data
const states = ref([]);
const cities = ref([]);
const errors = ref({});
const loading = ref(false);

// Map
const location = ref({
    lat: 34.8021,
    lng: 38.9968,
    address: ''
});


const onLocationChange = (newLocation) => {

    location.value = newLocation;

    branchForm.value.latitude =
        newLocation.lat != null
            ? String(newLocation.lat)
            : '';

    branchForm.value.longitude =
        newLocation.lng != null
            ? String(newLocation.lng)
            : '';
};

// User data
const fetchUserData = async () => {
    try {
        const response = await axios.get(
            '/users/service-provider/show-details',
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            }
        );
        userData.value = response.data;

    } catch (error) {
        console.error(
            'Error fetching user data:',
            error
        );
    }

};

// Sidebar category
const categoryName = computed(() => {
    return (
        userData.value
            ?.service_provider_details
            ?.category
            ?.name || ''
    );
});

// Sidebar state
const stateName = computed(() => {
    return (
        userData.value
            ?.service_provider_details
            ?.state
            ?.name || ''
    );
});

// Fetch states
const fetchStates = async () => {
    try {
        const response = await axios.get(
            '/get-states',
            {
                headers: {
                    locale: locale.value
                }
            }
        );
        states.value = response.data.states || [];
    } catch (error) {
        console.error(
            'Error fetching states:',
            error
        );
    }

};

// Fetch cities
const fetchCities = async (stateId) => {
    if (!stateId) {
        cities.value = [];
        return;
    }
    try {

        const response = await axios.get(
            `/get-cities/${stateId}`,
            {
                headers: {
                    locale: locale.value
                }
            }
        );

        cities.value = response.data.cities || [];

    } catch (error) {
        console.error(
            'Error fetching cities:',
            error
        );
    }

};

// Submit
const submitBranch = async () => {
    errors.value = {};
    if (!branchForm.value.translations.en.name) {
        errors.value['translations.en.name'] = [
            t('English branch name is required')
        ];
    }

    if (!branchForm.value.state_id) {
        errors.value.state_id = [
            t('State is required')
        ];
    }

    if (!branchForm.value.city_id) {
        errors.value.city_id = [
            t('City is required')
        ];
    }

    if (!branchForm.value.address) {
        errors.value.address = [
            t('Address is required')
        ];
    }
    if (Object.keys(errors.value).length > 0) {
        return;
    }

    loading.value = true;
    try {
        const formData = new FormData();

        formData.append(
            'translations[en][name]',
            branchForm.value.translations.en.name
        );

        formData.append(
            'translations[ar][name]',
            branchForm.value.translations.ar.name
        );

        formData.append(
            'translations[tr][name]',
            branchForm.value.translations.tr.name
        );

        formData.append('state_id', branchForm.value.state_id);
        formData.append('city_id', branchForm.value.city_id);
        formData.append('address', branchForm.value.address);
        formData.append('latitude', String(branchForm.value.latitude));
        formData.append('longitude', String(branchForm.value.longitude));
        const response = await axios.post(
            '/service-provider/branch/create',formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            }
        );
        toast.success(
            response.data?.msg ||
            t('Branch added successfully.')
        );
        router.push('/my-branches');
    } catch (error) {
        console.error(
            'Error creating branch:',
            error
        );
        if (error.response?.status === 422) {

            const validationErrors =
                error.response.data?.errors ||
                error.response.data ||
                {};

            errors.value = validationErrors;

            Object.values(validationErrors)
                .flat()
                .forEach(message => {
                    toast.error(message);
                });

        } else {
            toast.error(
                error.response?.data?.msg ||
                t('Something went wrong.')
            );
        }
    } finally {
        loading.value = false;
    }

};

// Back
const goBack = () => {
    router.push('/my-branches');
};

// Watch state -> cities
import { watch } from 'vue';
watch(
    () => branchForm.value.state_id,
    (newStateId) => {

        branchForm.value.city_id = '';

        fetchCities(newStateId);

    }
);

// Mounted
onMounted(() => {
    fetchUserData();
    fetchStates();
});

</script>


<style scoped>

.d-flex.gap-2 {
    align-items: center;
}

.dashboard-wraper {
    min-height: 400px;
}

</style>
